/**
 * Generate a random UUID with optional prefix
 * 
 * @param prefix - Prefix for the UUID (default: 'ua')
 * @returns A unique identifier string
 * 
 * @example
 * ```typescript
 * const id = KoreGenerateuuidPipe(); // 'ua-xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
 * const customId = KoreGenerateuuidPipe('msg'); // 'msg-xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
 * ```
 */
const KoreGenerateuuidPipe = (prefix: string = 'ua'): string => {
  let d = new Date().getTime();
  
  // Use high-precision timer if available (works in both browser and Node.js)
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now();
  }
  
  const uuid = `${prefix}-xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  
  return uuid;
};

export default KoreGenerateuuidPipe;

